/* eslint-disable @typescript-eslint/no-var-requires */
import { action, register, types } from "@gadgetinc/mobx-quick-tree";
import { encryptApplicationSecret } from "./appSecrets";
import { GadgetDomainModelClass, contentHash, getAppSettings } from "./utils";

@register
export class ConfigurationVariableValueContainer extends GadgetDomainModelClass("ConfigurationVariableValue", {
  isSecret: types.optional(types.boolean, false),
  value: types.maybeNull(types.string),
}) {
  get contentHash() {
    return contentHash([this.key, this.isSecret, this.value]);
  }

  @action
  setValue(incomingValue: string) {
    if (this.isSecret) {
      const publicKey = getAppSettings(this).secretsPublicKey;
      this.value = encryptApplicationSecret(incomingValue, publicKey);
    } else {
      this.value = incomingValue;
    }
  }
  @action
  makeSecret() {
    const oldValue = this.value;
    this.isSecret = true;
    if (oldValue) {
      this.setValue(oldValue);
    } else {
      this.value = null;
    }
  }
  @action
  makePublic() {
    this.isSecret = false;
    this.value = null;
  }
}
